import { BaseDialog, FlexBox } from '@airship-platform/jam-web/components';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { AppointmentSurvey } from '../../../../data-access/appointmentProposals';

type ProposalBuilderMediaChecklist = Pick<AppointmentSurvey, 'mediaChecklist'>;
type MediaChecklist = ProposalBuilderMediaChecklist['mediaChecklist'];

interface MediaChecklistModalProps {
  open: boolean;
  checklistOptions: MediaChecklist;
  selectedChecklist: MediaChecklist;
  onClose: ({ indoor, outdoor }: MediaChecklist) => void;
}

const MediaChecklistModal: React.FC<MediaChecklistModalProps> = ({
  open,
  checklistOptions,
  selectedChecklist,
  onClose,
}) => {
  const [checklistMode, setChecklistMode] = useState<'indoor' | 'outdoor'>(
    'outdoor'
  );

  const { control, getValues, setValue } =
    useForm<ProposalBuilderMediaChecklist>({
      defaultValues: {
        mediaChecklist: selectedChecklist,
      },
    });

  const handleChecklistChange = (
    type: 'indoor' | 'outdoor',
    option: string,
    checked: boolean
  ) => {
    const currentValues = getValues(`mediaChecklist.${type}`) || [];
    const updatedValues = checked
      ? [...currentValues, option]
      : currentValues.filter((value) => value !== option);

    setValue(`mediaChecklist.${type}`, updatedValues, {
      shouldValidate: true,
    });
  };

  const renderChecklist = () => {
    const options =
      checklistMode === 'outdoor'
        ? checklistOptions.outdoor
        : checklistOptions.indoor;
    const type = checklistMode;

    return options.map((option) => (
      <Controller
        key={`${type}-${option}`}
        name={`mediaChecklist.${type}`}
        control={control}
        render={({ field }) => {
          const isChecked = (field.value || []).includes(option);
          return (
            <FormControlLabel
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={(event) =>
                    handleChecklistChange(type, option, event.target.checked)
                  }
                />
              }
              label={option}
            />
          );
        }}
      />
    ));
  };

  return (
    <BaseDialog
      title={'Existing system checklist'}
      open={open}
      onClose={() => onClose(getValues().mediaChecklist)}
    >
      <FlexBox flexDirection={'column'} gap={4} p={4}>
        <FlexBox gap={1}>
          <Button
            color={checklistMode === 'outdoor' ? 'blue' : 'softBlue'}
            onClick={() => setChecklistMode('outdoor')}
            variant="contained"
          >
            Outdoor unit
          </Button>
          <Button
            color={checklistMode === 'indoor' ? 'blue' : 'softBlue'}
            onClick={() => setChecklistMode('indoor')}
            variant="contained"
          >
            Indoor unit
          </Button>
        </FlexBox>
        <FlexBox flexDirection={'column'} gap={1}>
          {renderChecklist()}
        </FlexBox>
      </FlexBox>
    </BaseDialog>
  );
};

export default MediaChecklistModal;
